/** @typedef {"auto" | "chat" | "whatsapp" | "order"} PrimaryCta */

/**
 * @typedef {Object} ResolvePrimaryCtaParams
 * @property {PrimaryCta} primaryCta
 * @property {string | null | undefined} chatUrl
 * @property {string | null | undefined} orderUrl
 * @property {string | null | undefined} whatsappUrl - from `buildWhatsAppApiSendUrlFromE164` (or legacy wa.me)
 */

/**
 * @typedef {Object} ResolvedPrimaryCta
 * @property {"chat" | "whatsapp" | "order"} kind
 * @property {string} href
 */

const isNonEmptyString = (v) => typeof v === "string" && v.trim().length > 0;

/**
 * Resolve which URL the primary button should open.
 *
 * @param {ResolvePrimaryCtaParams} params
 * @returns {ResolvedPrimaryCta | null}
 */
export function resolvePrimaryCta(params) {
  const { primaryCta, chatUrl, orderUrl, whatsappUrl } = params;

  const chat = isNonEmptyString(chatUrl) ? chatUrl.trim() : null;
  const order = isNonEmptyString(orderUrl) ? orderUrl.trim() : null;
  const wa = isNonEmptyString(whatsappUrl) ? whatsappUrl.trim() : null;

  if (primaryCta === "whatsapp") {
    return wa ? { kind: "whatsapp", href: wa } : null;
  }

  if (primaryCta === "chat") {
    return chat ? { kind: "chat", href: chat } : null;
  }

  if (primaryCta === "order") {
    return order ? { kind: "order", href: order } : null;
  }

  if (primaryCta === "auto") {
    if (wa) {
      return { kind: "whatsapp", href: wa };
    }
    if (chat) {
      return { kind: "chat", href: chat };
    }
    if (order) {
      return { kind: "order", href: order };
    }
    return null;
  }

  return null;
}
